/* DSL Referral tracking — capture ?ref={customer_id} en auto-credit on first purchase */
(function(){
  var p = new URLSearchParams(location.search);
  var ref = p.get("ref");
  if (ref) {
    try { localStorage.setItem("dsl_referrer", ref); } catch(e){}
    if (window.DSL_AB) window.DSL_AB.track("referral_visit", {ref: ref});
  }
  // Forward referrer to checkout via cart-attributes
  document.addEventListener("submit", function(e){
    var f = e.target;
    if (!f.action || f.action.indexOf("/cart/add") === -1) return;
    var stored;
    try { stored = localStorage.getItem("dsl_referrer"); } catch(e){}
    if (stored) {
      fetch("/cart/update.js", {method:"POST", headers:{"Content-Type":"application/json"}, body: JSON.stringify({attributes: {referrer: stored}})}).catch(function(){});
    }
  });
})();